import { Injectable } from '@angular/core';
import { ExternalChatboxService } from './services/chat-box/external-chatbox.service';

@Injectable()
export class ExternalToolsInitializerService {
  constructor(private chatBoxService: ExternalChatboxService) {}

  async initExternalTools() {
    await this.chatBoxService.initChatBoxTool();
  }
}
